module.exports = __webpack_public_path__ + "static/img/Lachie-Neale.b9faa0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie-Neale.jpg
// module id = 0WJB
// module chunks = 0